import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, Col, Form, Row, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { H3, Breadcrumbs, Btn, H4, Image } from '../../AbstractElements';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import DatePicker from 'react-datepicker';
import { getClientUrlDataToken } from '../../Utils/restUtils';
import { Export, Search, Filter, Bindcollections, Bindcollectionsrep } from '../../Constant';
import { getAccount, getAccountRole, getBinCollectionReport, getBinCollectionReportRole } from '../../CommonUrl';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Transparentspinner from '../Common/Loader/Transparentspinner';
import Progress from '../Common/Progress';
import { useForm } from 'react-hook-form';
import UserDropdown from '../Common Field/UserDropdown';
import AreaDropdown from '../Common Field/AreaDropdown';


const BinCollection = () => {
    const authState = useSelector((state) => state.auth);
    const location = useLocation();
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const [filters, setFilters] = useState({
        searchKey: params.get('search') || '',
        start_date: params.get('start_date') ? moment(params.get('start_date'), "DD-MM-YYYY").toDate() : '',
        end_date: params.get('end_date') ? moment(params.get('end_date'), "DD-MM-YYYY").toDate() : '',
        areaFilter: params.get('area') || '',
        accountId: params.get('account') || '',
        userId: params.get("user") || ''
    });
    const param1 = params.get("day") || '';
    const sortedBy = params.get("sortBy") || '';
    const sortedOrder = params.get("sortOrder") || '';
    const [customerLists, setCustomerList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [dateRange, setDateRange] = useState([filters.start_date, filters.end_date]);
    const [startDate, endDate] = dateRange
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' }
    const [apiAccount, setapiAccount] = useState([]);
    const [totalsum, settotalsum] = useState("0");
    const formatStartDate = filters.start_date ? moment(filters.start_date).format("DD-MM-YYYY") : '';
    const formatEndDate = filters.end_date ? moment(filters.end_date).format("DD-MM-YYYY") : '';
    const [sortConfig, setSortConfig] = useState({ column: sortedBy, order: sortedOrder });
    const { register, handleSubmit, setValue } = useForm({
        defaultValues: { search: filters.searchKey, area: filters.areaFilter, account: filters.accountId, user: filters.userId },
    });

    // const StaticWidgetsData = [
    //     {
    //         id: 1,
    //         title: 'Paid',
    //         counter: totalsum,
    //         svg: <EarningsSvg />,
    //         class: 'progress-gradient-secondary',
    //         progress: '75%'
    //     },
    // ];

    const BinDeactiveColumn = [
        {
            name: <H4>Sl</H4>,
            selector: row => row.Si,
            center: false,
            width: '80px'
        },
        {
            name: <H4>Bin Id</H4>,
            id: 'stb_no',
            selector: row => row.BinId,
            sortable: true,
            wrap: true,
            width: '105px',
        },
        {
            name: <H4>Name</H4>,
            id: 'customer_name',
            selector: row => row.Name,
            sortable: true,
            center: false,
            width: '170px',
        },
        {
            name: <H4>Location</H4>,
            selector: row => row.Location,
            center: true,
            width: '170px',
        },
        {
            name: <H4>Area</H4>,
            id: 'area_name',
            selector: row => row.Area,
            sortable: true,
            center: false,
            width: '150px',
        },
        {
            name: <H4>Bin Location</H4>,
            id: 'area_name',
            selector: row => row.BinLocation,
            // sortable: true,
            center: false,
            width: '150px',
        },
        {
            name: <H4>Lat Long Collection</H4>,
            id: 'area_name',
            selector: row => row.Latitude,
            // sortable: true,
            center: false,
            width: '190px',
            wrap:true
        },
        {
            name: <H4>Difference</H4>,
            id: 'difference',
            selector: row => row.Diff,
            sortable: true,
            center: false,
            width: '150px',
        },
        {
            name: <H4>Comments</H4>,
            id: 'comments',
            selector: row => row.Comment,
            sortable: true,
            center: false,
            width: '150px',
        },
        {
            name: <H4>Collected On</H4>,
            id: 'collected_at',
            selector: row => row.CollectedAt,
            sortable: true,
            center: false,
            width: '130px',
            wrap: true
        },

        {
            name: <H4>Collected By</H4>,
            id: 'driver_name',
            selector: row => row.CollectedBy,
            sortable: true,
            center: false,
            width: '130px',
            wrap: true
        },
    ];

    useEffect(() => {
        fetchCustomerPayment(1);
        accountData();
    }, []);

    useEffect(() => {
        setValue('search', filters.searchKey);
    }, [setValue, filters.search]);

    useEffect(() => {
        if (filters.accountId) {
            const selectedAccount = apiAccount.find((account) => account.id === parseInt(filters.accountId));
            if (selectedAccount) {
                setValue('account', selectedAccount.id.toString());
            }
        }
    }, [setValue, filters.accountId, apiAccount]);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleSort = (column) => {
        let newOrder = 'asc';
        if (sortedBy === column.id) {
            newOrder = sortedOrder === 'asc' ? 'desc' : 'asc';
            setSortConfig({ column: column.id, order: newOrder });
            navigate(`/report/bin-collection?search=${filters.searchKey}&start_date=${formatStartDate}&end_date=${formatEndDate}&area=${filters.areaFilter}&account=${filters.accountId}&user=${filters.userId}&sortBy=${column.id}&sortOrder=${newOrder}`);
        } else {
            newOrder = sortedOrder === 'asc' ? 'desc' : 'asc';
            setSortConfig({ column: column.id, order: newOrder });
            navigate(`/report/bin-collection?search=${filters.searchKey}&start_date=${formatStartDate}&end_date=${formatEndDate}&area=${filters.areaFilter}&account=${filters.accountId}&user=${filters.userId}&sortBy=${column.id}&sortOrder=${newOrder}`);
        }
    };

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const onSubmit = async (data) => {
        const searchKey = data.search || '';
        const start_date = startDate ? moment(startDate).format("DD-MM-YYYY") : '';
        const end_date = endDate ? moment(endDate).format("DD-MM-YYYY") : '';
        const areaFilter = data.area || '';
        const accountId = data.account || '';
        const userId = data.user || '';
        const queryParams = new URLSearchParams({
            search: searchKey,
            start_date,
            end_date,
            area: areaFilter,
            account: accountId,
            user: userId,
            sortBy: sortConfig.column || '',
            sortOrder: sortConfig.order || '',
        }).toString();
        navigate(`/report/bin-collection?${queryParams}`);
        setFilters({
            searchKey,
            start_date,
            end_date,
            areaFilter,
            accountId,
            userId
        });
        fetchCustomerPayment(currentPage, perPage);
    };

    const fetchCustomerPayment = async (page, size = perPage) => {
        setLoading(true);
        setCustomerList([]);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1
            ? getBinCollectionReport + `?page=${page}&page_length=${size}&search=${filters.searchKey}&area_id=${filters.areaFilter}
            &start_date=${formatStartDate}&end_date=${formatEndDate}&account_id=${filters.accountId}
            &user_id=${filters.userId}&day=${param1}&sort_by=${sortConfig.column ? sortConfig.column : ''}
            &sort_order=${sortConfig.order ? sortConfig.order : ''}`
            : getBinCollectionReportRole + `?page=${page}&page_length=${size}&search=${filters.searchKey}
            &area_id=${filters.areaFilter}&start_date=${formatStartDate}&end_date=${formatEndDate}
            &account_id=${filters.accountId}&user_id=${filters.userId}&sort_by=${sortConfig.column ? sortConfig.column : ''}
            &sort_order=${sortConfig.order ? sortConfig.order : ''}`
        );
        if (response.status === true) {
            const valuePackages = response.data.data;
            const SerialNo = (page - 1) * size + 1;
            const newCustomerList = Object.keys(valuePackages).map((e, index) => {
                return {
                    Si: SerialNo + index,
                    BinId: valuePackages[e].stb_no,
                    Name: valuePackages[e].customer_name,
                    Location: <div className='p-3'>
                        <Image attrImage={{ src: valuePackages[e].bin_image, alt: 'location', style: { width: '100px',objectFit: 'contain',borderRadius:'13px'  } }} />
                    </div>,
                    Area: valuePackages[e].area_name,
                    Latitude: valuePackages[e].lat && valuePackages[e].long
                        ? valuePackages[e].lat + ' + ' + valuePackages[e].long
                        : valuePackages[e].lat || valuePackages[e].long || '',
                    BinLocation: valuePackages[e].bin_lat && valuePackages[e].bin_long
                        ? valuePackages[e].bin_lat + ' + ' + valuePackages[e].bin_long
                        : valuePackages[e].bin_lat || valuePackages[e].bin_long || '',
                    Diff: valuePackages[e].difference === 0 ? 'Match' : 'Not Matching',
                    Comment: valuePackages[e].comments,
                    CollectedAt: valuePackages[e].collected_at,
                    CollectedBy: valuePackages[e].driver_name,
                    customer_id: valuePackages[e].customer_id,
                };
            });
            // settotalsum(response.data.total_amount);
            setCustomerList(newCustomerList);
            setTotalRows(response.data.total);
        } else {
            handleApiError(data.status);
        }
        setLoading(false);
    };

    const exportCollectionExcel = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getBinCollectionReport +
            `?export=payment_report&search=${filters?.searchKey ?? ''}&area_id=${filters?.areaFilter ?? ''}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&account_id=${filters?.account_Filter ?? ''}&user_id=${filters?.userId ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}` :
            getBinCollectionReportRole + `?export=payment_report&search=${filters?.searchKey ?? ''}&area_id=${filters?.areaFilter ?? ''}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&account_id=${filters?.account_Filter ?? ''}&user_id=${filters?.userId ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.map(({ stb_no, customer_name, bin_image, bin_lat, bin_long, area_name,service_address, lat, long, difference, collected_at, driver_name }, index) =>
            ({ Sl: index + 1, Bin_id: stb_no, Name: customer_name, Location: bin_image, Bin_Lat: bin_lat, Bin_long: bin_long, Area: area_name,Service_Address:service_address, Latitude: lat, Longitude: long, Difference: difference === 0 ? "Matching" : "Not Matching", Collected_on: collected_at, Collected_by: driver_name, }));
        if (response.status === true) {
            const ws = XLSX.utils.json_to_sheet(dataToExport);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Bin Collection Data');
            XLSX.writeFile(wb, 'bin_collection_report.xlsx');
        } else {
            handleApiError(data.status);
        }
        setLoading(false);
    };

    const exportCollectionPdf = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getBinCollectionReport +
            `?export=payment_report&search=${filters?.searchKey ?? ''}&area_id=${filters?.areaFilter ?? ''}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&account_id=${filters?.account_Filter ?? ''}&user_id=${filters?.userId ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}` :
            getBinCollectionReportRole + `?export=payment_report&search=${filters?.searchKey ?? ''}&area_id=${filters?.areaFilter ?? ''}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&account_id=${filters?.account_Filter ?? ''}&user_id=${filters?.userId ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.map(({ stb_no, customer_name, bin_image, bin_lat, bin_long, area_name, lat, long, difference, collected_at, driver_name }, index) =>
            ({ Sl: index + 1, Bin_id: stb_no, Name: customer_name, Location: bin_image, Bin_Lat: bin_lat, Bin_long: bin_long, Area: area_name, Latitude: lat, Longitude: long, Difference: difference === 0 ? "Matching" : "Not Matching", Collected_at: collected_at, Collected_by: driver_name, }));
        if (response.status === true) {
            const doc = new jsPDF();
            const columns = ["Sl", "Bin id", "Name", "Location", "Bin Lat", "Bin Long", "Area", "Lat", "Long", "Difference", "Collected On", "Collected By"];
            const rows = dataToExport.map(({ Sl, Bin_id, Name, Location, Bin_lat, Bin_long, Area, Latitude, Longitude, Difference, Collected_at, Collected_by }) => [Sl, Bin_id, Name, Location, Bin_lat, Bin_long, Area, Latitude, Longitude, Difference, Collected_at, Collected_by]);
            const columnWidths = [9, 10, 16, 20, 15, 15, 18, 15, 15, 18, 18, 13];

            doc.autoTable({
                head: [columns],
                body: rows,
                columnStyles: {
                    0: { cellWidth: columnWidths[0] },
                    1: { cellWidth: columnWidths[1] },
                    2: { cellWidth: columnWidths[2] },
                    3: { cellWidth: columnWidths[3] },
                    4: { cellWidth: columnWidths[4] },
                    5: { cellWidth: columnWidths[5] },
                    6: { cellWidth: columnWidths[6] },
                    7: { cellWidth: columnWidths[7] },
                    8: { cellWidth: columnWidths[8] },
                    9: { cellWidth: columnWidths[9] },
                    10: { cellWidth: columnWidths[10] },
                    11: { cellWidth: columnWidths[11] },
                },
            });
            doc.save("collection_data.pdf");
        } else {
            handleApiError(data.status);
        }
        setLoading(false);
    };

    const handlePageChange = page => {
        fetchCustomerPayment(page);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchCustomerPayment(page, newPerPage);
        setPerPage(newPerPage);
    };

    const accountData = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getAccount : getAccountRole);
        if (data.status === true) {
            setapiAccount(data.data);
        } else {
            handleApiError(data.status);
        }
    };

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle={Bindcollections} parent="Reports" title={Bindcollections} />
            {/* <Progress details={StaticWidgetsData} /> */}
            <Card className='cardWidth'>
                <CardHeader style={{ margin: '-25px 0 -25px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <H3>{Bindcollectionsrep}</H3>
                    <div>
                        {(authState.userRole === 1 || authState.permissions.includes('export-report')) &&
                            <CardBody className="dropdown-basic">
                                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                    <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4">
                                        {Export} <i className="icofont icofont-arrow-up"></i>
                                    </DropdownToggle>
                                    <DropdownMenu container="body">
                                        <DropdownItem style={toggleStyle} onClick={() => exportCollectionExcel()} ><i className="fa fa-file-excel-o me-2"></i> Excel</DropdownItem>
                                        <DropdownItem style={toggleStyle} onClick={() => exportCollectionPdf()}><i className="fa fa-file-pdf-o me-2"></i> Pdf</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </CardBody>
                        }
                    </div>
                </CardHeader>

                <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                    <Row className="ps-3 gap-sm-3 gap-md-2 filterGap">
                        <Col sm="12" md='5' lg='2'>
                            <input className="form-control" placeholder={Search} type="text"
                                {...register('search')} />
                        </Col>
                        <Col sm="12" md="5" lg='2' className="form-element" >
                            <div style={{ position: 'relative', zIndex: 2 }}>
                                <DatePicker
                                    className="form-control digits w-100"
                                    selectsRange={true}
                                    startDate={startDate}
                                    endDate={endDate}
                                    onChange={(update) => {
                                        setDateRange(update);
                                    }}
                                    isClearable={true}
                                    monthsShown={2}
                                    popperPlacement="bottom"
                                    calendarClassName='parallel-calendar'
                                    placeholderText='Select Date Range'
                                />
                            </div>
                        </Col>
                        <Col sm="12" md="5" lg='2' className="form-element">
                            <AreaDropdown
                                authState={authState}
                                registerName="area"
                                selectedAreaId={filters.areaFilter}
                                register={register}
                                setValue={setValue}
                            />
                        </Col>
                        {/* <Col sm="12" md="5" lg='2' className="form-element">
                            <select className="form-select" {...register('account')}>
                                <option value="">Bin Id</option>
                                {apiAccount.map((values, index) => (
                                    <option key={index} value={values.id}>{values.name}</option>
                                ))}
                            </select>
                        </Col> */}
                        {/* <Col sm="12" md="5" lg='2' className="form-element">
                            <select className="form-select" {...register('account')}>
                                <option value="">Collected By</option>
                                {apiAccount.map((values, index) => (
                                    <option key={index} value={values.id}>{values.name}</option>
                                ))}
                            </select>
                        </Col> */}
                        {/* <Col sm="12" md="5" lg='2' className="form-element">
                            <UserDropdown
                                authState={authState}
                                registerName="user"
                                selectedUserId={filters.userId}
                                register={register}
                                setValue={setValue}
                            />
                        </Col> */}
                        {/* <Col sm="12" md="5" lg='2' className="form-element">
                            <UserDropdown
                                authState={authState}
                                registerName="user"
                                selectedUserId={filters.userId}
                                register={register}
                                setValue={setValue}
                            />
                        </Col> */}
                        <Col sm="12" md="5" lg='1' className="custom-filtrs">
                            <Btn attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                        </Col>
                    </Row>
                </Form>
                <CardBody>
                    <div className="order-history table-responsive">
                        <DataTable
                            columns={BinDeactiveColumn}
                            data={customerLists}
                            onSort={handleSort} // Attach sorting handler here
                            sortServer // Enable server-side sorting
                            pagination
                            paginationServer
                            defaultSortAsc
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            fixedHeader
                        />
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default BinCollection;